import filterImageUrls from './filterImageUrls';
import { JobProperties } from '../components/Jobs/JobDetail/JobProperties';

const transformJob = (job: JobProperties) => {
  const {
    company,
    teaser,
    applyForm,
    template,
  } = job;
  const { logoUrls } = company;
  const filteredLogoUrls = filterImageUrls(logoUrls);

  return {
    ...job,
    company: {
      ...company,
      logoUrl: filteredLogoUrls,
    },
    qualifications: teaser,
    universalForm: applyForm,
    template: template.id,
  };
};

export default transformJob;
